import { v4 as uuid } from "uuid";
export const PROCEDURES_STEP_EVENTS_LIST_ID = "proceduresStepEventsList";
export const ATTRIBUTES = [
  {
    id: "message",
    title: "Title",
    type: "STRING",
    filterable: false
  },
  {
    id: "risk_score",
    title: "Risk Score",
    type: "DOUBLE",
    filterable: false
  },
  {
    id: "event_count",
    title: "Event Count",
    type: "INT",
    filterable: false
  },
  {
    id: "latest_event_at",
    title: "Latest Alert",
    type: "STRING"
  },
  {
    id: "earliest_event_at",
    title: "Earliest Alert",
    type: "STRING"
  }
];
export const listElements = {
  defaultLayout: {
    entityTableId: PROCEDURES_STEP_EVENTS_LIST_ID,
    defaultPageSize: 10,
    defaultSort: { attributeId: "risk_score", direction: "desc" },
    defaultDisplayedAttributes: ["message", "event_count", "risk_score", "latest_event_at", "earliest_event_at"],
    defaultColumnOrder: ["message", "event_count", "risk_score", "latest_event_at", "earliest_event_at"]
  }
};
export const deserializeProceduresStepEvents = (response) => {
  var _a;
  const { total, page, per_page, count, steps } = response;
  const entities = steps.map((step) => ({
    id: uuid(),
    message: step.procedure_step.title,
    risk_score: step.aggregates.risk.max,
    step: step.procedure_step,
    event_ids: step.aggregates.event_ids,
    event_count: step.aggregates.event_count,
    latest_event_at: step.aggregates.latest_event_at,
    earliest_event_at: step.aggregates.earliest_event_at
  }));
  return {
    attributes: ATTRIBUTES,
    list: entities,
    pagination: { total, page, per_page, count },
    meta: { first_event_id: (_a = entities[0]) == null ? void 0 : _a.id }
  };
};
